import axios from "axios";
import { CONFIG } from "../../config";
import { Sport } from "../../types/sport";
import { BetType } from "../../types/common";
import { providerQueryString } from "../../utils/providerQuery";
import { feedQueryString } from "../../utils/feedQuery";
class FeedService {
  private resultsClient = axios.create();

  public getNumberOfMatchType = async () => {
    const result = await axios.get(
      `${CONFIG.API_URL}/new-iframe/numberofmatches`,
    );

    return result?.data?.data;
  };

  public getResult = async (sportType: Sport, isToday?: boolean) => {
    const sportTypeText = sportType === Sport.FOOTBALL
      ? "soccer"
      : `${sportType}`.toLowerCase();
    const resultPath = isToday ? "result" : "result-previous";
    const result = await this.resultsClient.get(
      `https://staging-form-odds.askmebet.cloud/form/${resultPath}/${sportTypeText}`,
    );

    return result?.data;
  };

  public getFootball = async (
    type?: "today" | "live" | "early",
    betType?: BetType,
    provider?: string,
  ) => {
    const betTypeParam = betType ?? "normal";

    const mapBetType = {
      normal: "fb",
      step: "fbStep",
      comboStep: "comboFb",
    };

    const result = await axios.get(
      `${CONFIG.API_URL}/c/m/feed/${mapBetType[betTypeParam]}/${type}${feedQueryString(betType, provider, mapBetType[betTypeParam])}`,
    );

    return result?.data?.data;
  };

  public getBasketball = async (
    type?: "today" | "live" | "early",
    betType?: BetType,
    provider?: string,
  ) => {
    const betTypeParam = betType ?? "normal";

    const mapBetType = {
      normal: "bb",
      step: "bbStep",
      comboStep: "comboBb",
    };
    const result = await axios.get(
      `${CONFIG.API_URL}/c/m/feed/${mapBetType[betTypeParam]}/${type}${feedQueryString(betType, provider, mapBetType[betTypeParam])}`,
    );

    return result?.data?.data;
  };

  public getVolleyball = async (
    type?: "today" | "live" | "early",
    betType?: BetType,
  ) => {
    const betTypeParam = betType ?? "normal";

    const mapBetType = {
      normal: "vb",
      step: "vbStep",
      comboStep: "comboVb",
    };
    const result = await axios.get(
      `${CONFIG.API_URL}/c/m/feed/${mapBetType[betTypeParam]}/${type}${feedQueryString(betType, undefined, mapBetType[betTypeParam])}`,
    );

    return result?.data?.data;
  };

  public getTabletennis = async (
    type?: "today" | "live" | "early",
    betType?: BetType,
  ) => {
    const betTypeParam = betType ?? "normal";

    const mapBetType = {
      normal: "tt",
      step: "ttStep",
      comboStep: "comboTt",
    };
    const result = await axios.get(
      `${CONFIG.API_URL}/c/m/feed/${mapBetType[betTypeParam]}/${type}${feedQueryString(betType, undefined, mapBetType[betTypeParam])}`,
    );

    return result?.data?.data;
  };

  public getHandball = async (
    type?: "today" | "live" | "early",
    betType?: BetType,
  ) => {
    const betTypeParam = betType ?? "normal";

    const mapBetType = {
      normal: "hb",
      step: "hbStep",
      comboStep: "combohb",
    };
    const result = await axios.get(
      `${CONFIG.API_URL}/c/m/feed/${mapBetType[betTypeParam]}/${type}${feedQueryString(betType, undefined, mapBetType[betTypeParam])}`,
    );

    return result?.data?.data;
  };

  public getIcehockey = async (
    type?: "today" | "live" | "early",
    betType?: BetType,
  ) => {
    const betTypeParam = betType ?? "normal";

    const mapBetType = {
      normal: "ih",
      step: "ihStep",
      comboStep: "comboih",
    };
    const result = await axios.get(
      `${CONFIG.API_URL}/c/m/feed/${mapBetType[betTypeParam]}/${type}${feedQueryString(betType, undefined, mapBetType[betTypeParam])}`,
    );

    return result?.data?.data;
  };

  public getTennis = async (
    type?: "today" | "live" | "early",
    betType?: BetType,
  ) => {
    const betTypeParam = betType ?? "normal";

    const mapBetType = {
      normal: "tn",
      step: "tnStep",
      comboStep: "combotn",
    };
    const result = await axios.get(
      `${CONFIG.API_URL}/c/m/feed/${mapBetType[betTypeParam]}/${type}${feedQueryString(betType, undefined, mapBetType[betTypeParam])}`,
    );

    return result?.data?.data;
  };

  public getSnooker = async (
    type?: "today" | "live" | "early",
    betType?: BetType,
  ) => {
    const betTypeParam = betType ?? "normal";

    const mapBetType = {
      normal: "sn",
      step: "snStep",
      comboStep: "combosn",
    };
    const result = await axios.get(
      `${CONFIG.API_URL}/c/m/feed/${mapBetType[betTypeParam]}/${type}${feedQueryString(betType, undefined, mapBetType[betTypeParam])}`,
    );

    return result?.data?.data;
  };

  public getBaseball = async (
    type?: "today" | "live" | "early",
    betType?: BetType,
  ) => {
    const betTypeParam = betType ?? "normal";

    const mapBetType = {
      normal: "baseball",
      step: "baseballStep",
      comboStep: "combobaseball",
    };
    const result = await axios.get(
      `${CONFIG.API_URL}/c/m/feed/${mapBetType[betTypeParam]}/${type}${feedQueryString(betType, undefined, mapBetType[betTypeParam])}`,
    );

    return result?.data?.data;
  };

  public getRugby = async (
    type?: "today" | "live" | "early",
    betType?: BetType,
  ) => {
    const betTypeParam = betType ?? "normal";

    const mapBetType = {
      normal: "rugby",
      step: "rugbyStep",
      comboStep: "comborugby",
    };
    const result = await axios.get(
      `${CONFIG.API_URL}/c/m/feed/${mapBetType[betTypeParam]}/${type}${feedQueryString(betType, undefined, mapBetType[betTypeParam])}`,
    );

    return result?.data?.data;
  };

  public getAmericanfootball = async (
    type?: "today" | "live" | "early",
    betType?: BetType,
  ) => {
    const betTypeParam = betType ?? "normal";

    const mapBetType = {
      normal: "american_football",
      step: "american_footballStep",
      comboStep: "comboamerican_football",
    };
    const result = await axios.get(
      `${CONFIG.API_URL}/c/m/feed/${mapBetType[betTypeParam]}/${type}${feedQueryString(betType, undefined, mapBetType[betTypeParam])}`,
    );

    return result?.data?.data;
  };

  public getBadminton = async (
    type?: "today" | "live" | "early",
    betType?: BetType,
  ) => {
    const betTypeParam = betType ?? "normal";

    const mapBetType = {
      normal: "badminton",
      step: "badmintonStep",
      comboStep: "combobadminton",
    };
    const result = await axios.get(
      `${CONFIG.API_URL}/c/m/feed/${mapBetType[betTypeParam]}/${type}${feedQueryString(betType, undefined, mapBetType[betTypeParam])}`,
    );

    return result?.data?.data;
  };

  public getCricket = async (type?: "today" | "live" | "early") => {
    const result = await axios.get(
      `${CONFIG.API_URL}/c/m/feed/cricket/${type}${feedQueryString(undefined, undefined, "cricket")}`,
    );

    return result?.data?.data;
  };

  public getCockfight = async (type?: "today" | "live" | "early") => {
    const result = await axios.get(
      `${CONFIG.API_URL}/c/m/feed/cock_fight/${type}${feedQueryString(undefined, undefined, "cock_fight")}`,
    );

    return result?.data?.data;
  };

  public getBullfight = async (type?: "today" | "live" | "early") => {
    const result = await axios.get(
      `${CONFIG.API_URL}/c/m/feed/bull_fight/${type}${feedQueryString(undefined, undefined, "bull_fight")}`,
    );

    return result?.data?.data;
  };

  public getBoxing = async (type?: "today" | "live" | "early") => {
    const result = await axios.get(
      `${CONFIG.API_URL}/c/m/feed/boxing/${type}${feedQueryString(undefined, undefined, "boxing")}`,
    );

    return result?.data?.data;
  };

  public getSpecialPrices = async (
    sport: string,
    matchId: number,
    table: string,
    provider = "",
  ) => {
    const providerQuery = providerQueryString(provider, sport).replace("?", "&");
    const result = await axios.get(
      `${CONFIG.API_URL}/c/m/feed/special-price/${sport}/${matchId}?table=${encodeURIComponent(table)}${providerQuery}`,
    );

    return result?.data;
  };

  public getTopeventFoottabll = async () => {
    const result = await axios.get(
      `${CONFIG.API_URL}/new-iframe/topevent/FOOTBALL`,
    );

    return result?.data?.data;
  };
}

export default FeedService;
